import { useLiquidityCachePools } from '../hooks/useLiquidityCachePools';
import { PoolCard } from '../components/PoolCard';
import { Button } from '@/components/ui/button';

export function PoolListPage() {
  const { pools, loading, error, refresh, loadMore, hasMore } = useLiquidityCachePools();

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold">Exchange Caches</h1>
        <Button variant="outline" size="sm" onClick={refresh}>
          Refresh
        </Button>
      </div>

      {error && <p className="text-sm text-red-600">{error}</p>}

      {loading && pools.length === 0 ? (
        <p className="text-muted-foreground">Loading caches...</p>
      ) : pools.length === 0 ? (
        <p className="text-muted-foreground">No active exchange caches yet.</p>
      ) : (
        <>
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {pools.map((pool) => (
              <PoolCard key={pool.poolId} pool={pool} />
            ))}
          </div>
          {hasMore && (
            <div className="text-center">
              <Button variant="outline" onClick={loadMore} disabled={loading}>
                Load More
              </Button>
            </div>
          )}
        </>
      )}
    </div>
  );
}
